export const BANK_POALIM = '12';
export const BANK_LEUMI = '10';
export const BANK_DISCOUNT = '11';
export const BANK_BINLEUMI = '31';
export const BANK_MIZRACHI_TTEFAHOT = '20';
export const BANK_OTSAR = '14';
export const BANK_MERCANTILE = '17';
export const BANK_OTHER = 'other';

export const banks = {
  [BANK_POALIM]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק (לא ניתן באפליקציה) > עובר ושב > הרשאות והוראות קבע > הקמת הרשאה',
      'מקלידים את קוד המוסד – 22827 (אין צורך במספר אסמכתא)',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://login.bankhapoalim.co.il'
  },
  [BANK_LEUMI]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק (לא ניתן באפליקציה) > תשלומים > פתיחת הרשאה לחיוב חשבון',
      'מקלידים את קוד המוסד – 22827 (אין צורך במספר אסמכתא)',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://hb2.bankleumi.co.il'
  },
  [BANK_DISCOUNT]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק (לא ניתן באפליקציה) > תשלומים > פתיחת הרשאה לחיוב חשבון',
      'מקלידים את קוד המוסד – 22827 (אין צורך במספר אסמכתא)',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://www.discountbank.co.il'
  },
  [BANK_BINLEUMI]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק (לא ניתן באפליקציה) > תפריט ניהול חשבון > הקמת הרשאה',
      'מקלידים את קוד המוסד – 22827 (אין צורך במספר אסמכתא)',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://online.fibi.co.il'
  },
  [BANK_MIZRACHI_TTEFAHOT]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק (לא ניתן באפליקציה) > תפריט עו"ש > העברות ותשלומים> הרשאות והוראות קבע',
      'מקלידים את קוד המוסד – 22827 / מס אסמכתא 366366',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://www.mizrahi-tefahot.co.il'
  },
  [BANK_OTSAR]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק ( לא ניתן באפליקציה)>(ניהול חשבון>חיובים על פי הרשאה>הקמת הרשאה לחיוב חשבון',
      'מקלידים את קוד המוסד – 22827',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://online.bankotsar.co.il'
  },
  [BANK_MERCANTILE]: {
    instructions: (minimumSum, minimumExpiry) => [
      'נכנסים לחשבון באתר הבנק (לא ניתן באפליקציה) > תפריט עו"ש > העברות ותשלומים>בקשה להרשאה חדשה',
      'מקלידים את קוד המוסד – 22827',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`,
      ' בסיום הפעולה יינתן אישור על הקמת ההרשאה. לשאלות ותמיכה ניתן לפנות אלינו בהודעה - 053844484'
    ],
    website: 'https://www.mercantile.co.il'
  },
  [BANK_OTHER]: {
    instructions: (minimumSum, minimumExpiry) => [
      'לצערנו הבנק שלך אינו מפרסם הנחיות  לפתיחת הרשאת חיוב אנא פנה ישירות לבנק שלך ותבקש לפתוח הרשאת חיוב, הבנק יבקש את הפרטים הבאים -',
      'קוד מוסד - 22827',
      `הגבלות - מומלץ לא להגביל <small>(במידה ותרצו בכל זאת להגביל, סכום ההגבלה המינמלי הינו  ${minimumSum} ש״ח ובתוקף עד לתאריך ${minimumExpiry})</small>`
    ]
  }
};



// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/BankInstructions/instructionsByBank.js